module.exports = __webpack_public_path__ + "img/IMG_0079_L_WoodMatted.9922788f.jpg";